














































































































































































































































import mixins from '@/utils/mixins';
import links from '@/data/drawerItems.json';
import { mapGetters } from 'vuex';

import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import { Group } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';
import { isArray } from '@/utils/helpers';
import ALPage from '@/components/core/Page/ALPage.vue';
import { gridSize } from '@/theme/constants';
import auth from '@/mixins/auth';
import DashboardCard from '@/components/core/Dashboard/DashboardCard.vue';
import app, { NavigationLink } from '@/mixins/app';
import { IWorkflowFormTemplate } from '@/models';

export interface IWeatherParams {
  latitude: string;
  longitude: string;
  current_weather: string;
  timezone: string;
}

export interface IWeatherData {
  current_weather: ICurrentWeather;
  elevation: number;
  generationtime_ms: number;
  latitude: number;
  longitude: number;
  timezone: string;
  timezone_abbreviation: string;
  utc_offset_seconds: number;
}

export interface ICurrentWeather {
  temperature: number;
  windspeed: number;
  winddirection: number;
  weathercode: number;
  time: string;
}

export default mixins(auth, app).extend({
  name: 'HomePage',

  components: { ALPage, DashboardCard },

  metaInfo: {
    title: 'Overview'
  },

  data() {
    return {
      now: 0,

      weather: {} as IWeatherData,
      weatherLoading: false,
      dateInterval: undefined as number | undefined
    };
  },

  computed: {
    ...mapGetters({
      workflowFormTemplates:
        'workflowFormTemplate/getWorkflowFormTemplatesWithPublishedRevisions'
    }),
    authProvider(): any {
      return authProvider(this.$store);
    },

    links(): NavigationLink {
      const userGroups: Group[] = this.authProvider.getCurrentUser.groups ?? [];
      const linkGroup = [] as any;

      for (let index = 0; index < links.length; index++) {
        if (!links[index].divider) {
          if (links[index].showChildren) {
            if (
              isArray(links[index].children) &&
              links[index].children!.length > 0
            ) {
              for (
                let childIndex = 0;
                childIndex < links[index].children!.length;
                childIndex++
              ) {
                if (
                  this.checkUserHasRoles(
                    userGroups,
                    links[index].children![childIndex]
                  )
                ) {
                  linkGroup.push(links[index].children![childIndex]);
                }
              }
              continue;
            }
          }
          if (this.checkUserHasRoles(userGroups, links[index])) {
            linkGroup.push(links[index]);
          }
        }
      }
      return linkGroup;
    },

    userAppLinks(): NavigationLink[] {
      return this.workflowFormTemplates.map(
        (template: IWorkflowFormTemplate) =>
          ({
            text: template.title,
            description: template.description,
            icon: 'mdi-text-box-outline',
            to: 'workflow-form-submission-list',
            params: { id: template.id! },
            mandatory_roles: this.userHasRoles(['Form Admin'])
              ? []
              : ['Form Submission User'],
            color: 'primary',
            namespace: 'joma'
          } as NavigationLink)
      );
    },

    offsetYMargin(): number {
      return this.$vuetify.application.top + gridSize();
    },

    primaryHeaderStyles(): Record<string, string | number> {
      return {
        // zIndex: '5 !important',
        padding: '0 !important',
        marginTop: `-${this.offsetYMargin}px`
      };
    }
  },

  mounted() {
    //gets user's current geo location
    navigator.geolocation.getCurrentPosition(
      this.successCallback,
      this.errorCallback
    );

    this.updateNow();
    this.dateInterval = setInterval(() => this.updateNow(), 30000);
  },

  beforeDestroy() {
    this.clearInterval();
  },

  methods: {
    clearInterval() {
      clearInterval(this.dateInterval);
    },

    updateNow(): any {
      this.now = Date.now();
    },

    checkUserHasRoles(userGroups: Group[], link: any): boolean {
      const isRestrictedLink = link.roles?.length ?? 0 > 0;
      const userHasRole = isRestrictedLink
        ? userGroups.some(group => link.roles?.includes(group.name!))
        : true;
      return userHasRole || this.authProvider.isUserAdmin;
    },

    //it's of type GeolocationPosition however there is typescript problem on compile
    //https://stackoverflow.com/questions/65916073/angular-11-why-cant-the-compiler-find-geolocationposition-during-compiling
    successCallback(position: any) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const params = {
        latitude: position.coords.latitude.toString(),
        longitude: position.coords.longitude.toString(),
        current_weather: 'true',
        timezone: timezone
      };

      this.genWeatherForcast(params);
    },

    //user blocks geo location
    errorCallback(error: any) {
      console.log(error);
    },

    async genWeatherForcast(params: IWeatherParams) {
      this.weatherLoading = true;
      await fetch(
        'https://api.open-meteo.com/v1/forecast?' +
          new URLSearchParams({ ...params })
      )
        .then(async response => {
          this.weather = await response.json();
        })
        .catch(this.errorCallback)
        .finally(() => {
          this.weatherLoading = false;
        });
    }
  }
});
